// Speed units data for conversion routes
// Base unit: meter per second (m/s)

export const speedUnits = [
  { id: 'meter-per-second', name: 'Meter per second', symbol: 'm/s', plural: 'Meters per second', factor: 1 },
  { id: 'kilometer-per-hour', name: 'Kilometer per hour', symbol: 'km/h', plural: 'Kilometers per hour', factor: 0.277778 },
  { id: 'mile-per-hour', name: 'Mile per hour', symbol: 'mph', plural: 'Miles per hour', factor: 0.44704 },
  { id: 'foot-per-second', name: 'Foot per second', symbol: 'ft/s', plural: 'Feet per second', factor: 0.3048 },
  { id: 'knot', name: 'Knot', symbol: 'kn', plural: 'Knots', factor: 0.514444 },
  { id: 'mach', name: 'Mach', symbol: 'Ma', plural: 'Mach', factor: 340.29 },
  { id: 'speed-of-light', name: 'Speed of light', symbol: 'c', plural: 'Speed of light', factor: 299792458 },
  { id: 'centimeter-per-second', name: 'Centimeter per second', symbol: 'cm/s', plural: 'Centimeters per second', factor: 0.01 },
  { id: 'millimeter-per-second', name: 'Millimeter per second', symbol: 'mm/s', plural: 'Millimeters per second', factor: 0.001 },
  { id: 'kilometer-per-second', name: 'Kilometer per second', symbol: 'km/s', plural: 'Kilometers per second', factor: 1000 },
  { id: 'mile-per-second', name: 'Mile per second', symbol: 'mi/s', plural: 'Miles per second', factor: 1609.344 },
];

// Popular conversions matching common usage
export const popularSpeedConversions = [
  { from: 'mile-per-hour', to: 'kilometer-per-hour' },
  { from: 'kilometer-per-hour', to: 'mile-per-hour' },
  { from: 'meter-per-second', to: 'kilometer-per-hour' },
  { from: 'kilometer-per-hour', to: 'meter-per-second' },
  { from: 'knot', to: 'mile-per-hour' },
  { from: 'mile-per-hour', to: 'knot' },
  { from: 'knot', to: 'kilometer-per-hour' },
  { from: 'kilometer-per-hour', to: 'knot' },
  { from: 'meter-per-second', to: 'mile-per-hour' },
  { from: 'mile-per-hour', to: 'meter-per-second' },
  { from: 'foot-per-second', to: 'meter-per-second' },
  { from: 'meter-per-second', to: 'foot-per-second' },
  { from: 'foot-per-second', to: 'mile-per-hour' },
  { from: 'mile-per-hour', to: 'foot-per-second' },
  { from: 'mach', to: 'kilometer-per-hour' },
  { from: 'kilometer-per-hour', to: 'mach' },
  { from: 'mach', to: 'mile-per-hour' },
  { from: 'mile-per-hour', to: 'mach' },
  { from: 'speed-of-light', to: 'kilometer-per-second' },
  { from: 'kilometer-per-second', to: 'speed-of-light' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return speedUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertSpeed = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to m/s first, then to target unit
  const metersPerSecond = value * fromUnit.factor;
  return metersPerSecond / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertSpeed(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online speed unit converter.`;
};
